"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getError = exports.getSearchText = exports.UserSingleValue = exports.UserOption = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var monocle = require("monocle-ts");
var react_select_1 = require("react-select");
var Option_1 = require("react-select/lib/components/Option");
var sok_ui_1 = require("@caddigital/sok-ui");
var Row = sok_ui_1.Grid.Row, Column = sok_ui_1.Grid.Column;
var ContractFiles_1 = require("./ContractFiles");
var PictureSelector_1 = require("./PictureSelector");
var avatars_1 = require("components/Avatar/avatars");
var constants_1 = require("utils/constants");
var timeout = null;
/**
 * return current value from value object
 * @param key field name
 * @param state value object
 */
var valueLens = function (key, state) {
    var val = monocle.Lens.fromProp(key).get(state);
    if (key === 'hasBusinessId') {
        return !val;
    }
    return val;
};
/**
 * list of form fields
 */
var getInputs = function () { return [
    {
        name: 'companyName',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/company'),
        type: 'textinput'
    },
    {
        name: 'businessId',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/businessID'),
        type: 'textinput'
    },
    {
        name: 'hasBusinessId',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/noBusinessId'),
        type: 'checkbox'
    },
    {
        name: 'street',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/address'),
        type: 'textinput'
    },
    {
        name: 'postalCode',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/postalCode'),
        type: 'textinput'
    },
    {
        name: 'city',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/city'),
        type: 'textinput'
    },
    {
        name: 'state',
        label: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/stateProvince'),
        type: 'textinput'
    }
]; };
/**
 * Salesman list
 * @param props
 */
var UserOption = function (props) { return (React.createElement(Option_1.default, __assign({}, props),
    React.createElement("div", { className: 'salesman-select-item' },
        React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(props.data.avatar) }),
        React.createElement("div", { className: 'salesman-info' },
            React.createElement("div", null,
                props.data.firstName,
                " ",
                props.data.lastName),
            React.createElement("div", null, props.data.email))))); };
exports.UserOption = UserOption;
/**
 * Selected salesman item
 * @param props
 */
var UserSingleValue = function (props) { return (React.createElement("div", { className: 'Select-value' },
    React.createElement("div", { className: 'Select-value-label salesman-value-label' },
        React.createElement("img", { src: (0, avatars_1.getAvatarUrl)(props.data.avatar) }),
        React.createElement("span", null,
            props.data.firstName,
            " ",
            props.data.lastName,
            " (",
            props.data.email,
            ")")))); };
exports.UserSingleValue = UserSingleValue;
/**
 * For YTJ search
 * @param isFetching
 * @return message
 */
var getSearchText = function (isFetching) {
    return isFetching
        ? (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/searchingCompany')
        : (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/noResults');
};
exports.getSearchText = getSearchText;
/**
 * Return validation error
 * @param key
 * @param values
 */
var getError = function (key, step1) {
    if (step1.status === 'ERROR') {
        var errors = step1.errors[key];
        if (errors) {
            return React.createElement("p", { className: 'form-error' }, errors[0]);
        }
    }
    return undefined;
};
exports.getError = getError;
//#region COMPONENT
/**
 * New Customer form
 */
exports.default = (function (props) { return (React.createElement("div", { className: 'step1-new-customer' },
    React.createElement(Row, null,
        React.createElement(Column, null,
            React.createElement("div", null,
                React.createElement(PictureSelector_1.default, { uuid: props.wizard.customerUuid, setFile: props.setCompanyLogo, removePicture: props.removeCompanyLogo, dataUrl: props.step1.companyLogo.dataUrl })))),
    React.createElement(Row, null,
        React.createElement(Column, null,
            React.createElement("label", { className: 'customer-label' }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/SearchByVatOrCompanyName')),
            React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/SearchByVatOrCompanyName'), menuPlacement: 'auto', options: props.ytj.companies, getOptionValue: function (opt) { return opt.businessId; }, getOptionLabel: function (opt) { return opt.name; }, isClearable: false, isLoading: props.ytj.isFetching, onInputChange: function (e) {
                    var value = e;
                    props.setTempValue(value);
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(function () {
                        props.setYtjSearchString(value);
                        props.setTempValue(null);
                    }, constants_1.SEARCH_TIMEOUT);
                }, onChange: props.setCompany, noOptionsMessage: function () { return (0, exports.getSearchText)(props.ytj.isFetching); } }))),
    React.createElement(Row, null,
        React.createElement(Column, { className: 'loading-company' }, props.wizard.fetchingSelectedCompany === 'FETCHING' && (React.createElement("div", null,
            React.createElement(sok_ui_1.LoadingSpinner, null),
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/loadingCompany')))))),
    getInputs().map(function (input, key) { return (React.createElement(Row, { key: key },
        React.createElement(Column, null,
            React.createElement("label", { className: 'customer-label', htmlFor: input.name }, input.label),
            input.type === 'textinput' ? (React.createElement(sok_ui_1.TextInput, { id: input.name, className: 'white', placeholder: input.label, value: valueLens(input.name, props.step1), onChange: function (e) {
                    props.updateField(input.name)(e.target.value);
                    if (input.name === 'businessId' && !props.step1.hasBusinessId) {
                        props.updateField('hasBusinessId')(true);
                    }
                } })) : (React.createElement(sok_ui_1.Input, { type: 'checkbox', name: input.name, value: valueLens(input.name, props.step1), onClick: function (e) {
                    if (input.name === 'hasBusinessId') {
                        props.updateField('businessId')('');
                        props.updateField(input.name)(!e.target.checked);
                    }
                    else {
                        props.updateField(input.name)(e.target.checked);
                    }
                } })),
            (0, exports.getError)(input.name, props.step1)))); }),
    React.createElement(Row, null,
        React.createElement(Column, null,
            React.createElement("label", { className: 'customer-label' }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/country')),
            React.createElement(react_select_1.default, { classNamePrefix: "react-select", menuPlacement: 'auto', placeholder: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/country'), value: props.region.list.find(function (a) { return props.step1.country === a.code; }), options: props.region.list, onChange: props.setCountry, getOptionValue: function (opt) { return opt.code; }, getOptionLabel: function (opt) { return opt.name; }, isClearable: false }),
            (0, exports.getError)('country', props.step1))),
    React.createElement(Row, null,
        React.createElement(Column, null,
            React.createElement("label", { className: 'customer-label' }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/salesmanRepresentive')),
            React.createElement(react_select_1.default, { classNamePrefix: "react-select", placeholder: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/salesmanRepresentive'), value: props.salesman.list.find(function (s) { return s.id === props.step1.salesman; }), menuPlacement: 'auto', options: props.salesman.list, onChange: props.setSalesman, components: {
                    Option: exports.UserOption,
                    SingleValue: exports.UserSingleValue
                }, getOptionValue: function (opt) { return opt.id; }, getOptionLabel: function (opt) { return opt.email; }, isClearable: false }),
            (0, exports.getError)('salesman', props.step1))),
    React.createElement(Row, null,
        React.createElement(Column, null,
            React.createElement(ContractFiles_1.default, __assign({}, props)))),
    React.createElement(Row, null,
        React.createElement(Column, null,
            React.createElement("label", { className: 'customer-label', htmlFor: 'is-client' }, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/client')),
            React.createElement(sok_ui_1.Input, { id: 'is-client', type: 'checkbox', value: props.step1.client, onChange: props.toggleClient }))))); });
//#endregion
